import { StorageServiceObservablesService } from './../storage-service-observables/storage-service-observables.service';
import { HttpClient } from '@angular/common/http';
import { UserService } from './../user.service';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root',
})
export class AuthenticateUserService {
  
  constructor(
    private http: HttpClient,
    private userService: UserService,
    private storageService: StorageServiceObservablesService
  ) {}

  authenticateCurrentPassword(password) {
    const url = `${environment.backend_server_url_identity}/v2/authenticate`;
    const body = {
      email: this.storageService.getUserFromStorage(),
      password,
    };
    return this.http.post(url, body);
  }

  changeUserPassword(newPassword) {
    return this.userService.$user.pipe(
      map((user) => {
        const url = `${environment.backend_server_url_identity}/password/${user.email.address}?newPassword=${newPassword}`;
        return this.http.post(url, {});
      })
    );
  }
}
